import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { IonItem, IonLabel, IonList } from '@ionic/react';
import OrderActions, { OrderSelectors } from 'redux/OrderRedux';
import { formatCurrency } from 'utils/currency';
import CartItem from './CartItem';

function OrderCart({ venueId }) {
  const history = useHistory();
  const cartItems = useSelector(OrderSelectors.selectCartItems(venueId));
  
  const subtotal = useSelector(OrderSelectors.selectCartSubtotal(venueId));
  const dispatch = useDispatch();
  const handleEdit = (cartItem) => {
    history.push(`/locations/${venueId}/cart/add/${cartItem.item.id}`, {
      direction: 'forward',
      quantity: cartItem.quantity,
      uuid: cartItem.uuid,
    });
  };
  const handleDelete = (cartItem) => {
    dispatch(OrderActions.deleteItemFromCart(cartItem.uuid));
  };

  return (
    <IonList>
      {cartItems.map((c) => (
        <CartItem
          key={c.uuid}
          venueId={venueId}
          cartItem={c}
          onDelete={() => handleDelete(c)}
          onEdit={() => handleEdit(c)}
        />
      ))}
      <IonItem lines="full">
        <IonLabel>
          <h3>Subtotal</h3>
        </IonLabel>
        <IonLabel slot="end" className="menuitem-price">
          <h3>{formatCurrency(subtotal)}</h3>
        </IonLabel>
      </IonItem>
    </IonList>
  );
}

OrderCart.propTypes = {
  venueId: PropTypes.string,
};

export default OrderCart;
